import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-night" data-id="element-20" data-mp="vtnxirotfgtu">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-21" data-mp="qu2xsf1tn4g2">
        <Reveal className="text-center" data-id="element-22" data-mp="qvw7y4bn86st">
          <h2 id="bonos" className="font-display text-xl uppercase leading-tight text-volt sm:text-3xl lg:text-4xl" data-id="element-23" data-mp="14t2p5ugpxxfx">
            🎁 5 Bonos incluidos
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-24" data-mp="1ejxbszxvmz1w">
            Y para ayudarte a llevar lo aprendido mucho más allá, hoy también
            recibes estos 5 recursos complementarios sin costo adicional.
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="1jiqpoth2ss2l">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-volt/40 bg-carbon p-4" data-id="element-26" data-mp="3pqttajeazveb" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-display text-[0.92rem] uppercase leading-tight text-white sm:text-[0.98rem]" data-id="element-27" data-mp="2kkscrzdrg05">
                <GiftIcon size={16} className="mt-0.5 flex-shrink-0 text-volt" strokeWidth={2.5} data-id="element-28" data-mp="7m0aoca6b8eu" />
                {bono.title}
              </h3>
              <p className="mt-2 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-29" data-mp="gj0zgk15n8it">
                {bono.desc}
              </p>
              <p className="mt-1.5 font-script text-lg leading-tight text-volt" data-id="element-30" data-mp="qbq691lrfy7t">
                {bono.tag}
              </p>
              <div className="mt-auto flex items-center justify-between gap-2 border-t border-white/10 pt-3" data-id="element-31" data-mp="vbkwr41milsc">
                <span className="text-[0.75rem] text-steel line-through sm:text-sm" data-id="element-32" data-mp="109w5tck3gs9i">
                  Valor: {bono.value}
                </span>
                <span className="rounded bg-volt px-2 py-0.5 font-display text-[0.7rem] uppercase text-carbon sm:text-xs" data-id="element-33" data-mp="5me5s0yk4gwb">
                  🔥 Hoy: Gratis
                </span>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-xl border-2 border-volt bg-volt/10 p-4 text-center" data-id="element-34" data-mp="fjag8c80nd3i">
            <p className="font-display text-[0.85rem] uppercase leading-tight text-volt sm:text-base" data-id="element-35" data-mp="obu72qi2gdds">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="mt-1 font-display text-3xl text-white line-through decoration-danger decoration-2 sm:text-4xl" data-id="element-36" data-mp="yb31tlkr9w17">
              {BONUS_VALUE}
            </p>
            <p className="mt-2 text-[0.8rem] font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-37" data-mp="353dju8svm7rw">
              Hoy te llevas los 5 bonos:
            </p>
            <p className="mt-1 font-display text-xl uppercase text-volt sm:text-2xl" data-id="element-38" data-mp="1flgmo4jqaxgc">
              🎁 Gratis con tu compra
            </p>
          </Reveal>
        </ul>

        <Reveal delay={0.2} className="mt-5 flex justify-center" data-id="element-39" data-mp="15uudas2lv363">
          <CtaButton size="lg" data-id="element-40" data-mp="15shy2mo8f6wq">
            ¡SÍ! QUIERO APRENDER ELECTRICIDAD DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}